import { AGENT_ROLES_OPTIONS } from '@constants';

const normalizeAgents = (data = []) => {
  if (!data.length) {
    return [];
  }

  const agentsData = data?.map((item) => {
    return {
      ...item,
      role: AGENT_ROLES_OPTIONS[`is${item?.role}`]?.text || '',
    };
  });

  return agentsData?.sort((a, b) => a.text?.localeCompare(b?.text));
};

export default normalizeAgents;
